import {useState} from "react";
import {useForm, Controller, useWatch} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import _ from "lodash";
import {Alert, notification} from "antd";
import {
    Button,
    Loading
} from "~/components";
import {
    GroupRadioField,
    InputField,
    SelectServiceAll
} from "~/components/Forms";
import {apiError, handleRequest} from "~/utils";
import {serviceApi} from "~/api";

function ToDoFormRedirectDomain({onHandleSubmit})
{
    const initialValues = {
        fromDomain: "",
        toDomain: ""
    }

    const validationSchema = Yup.object().shape({
        fromDomain: Yup.string().required('Bạn chưa điền tên miền hiện tại'),
        toDomain: Yup.string().required('Bạn chưa điền tên miền mới'),
    })

    const { control, handleSubmit, formState: { isSubmitting, errors }, reset, setValue } = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = async (data) => {
        await onHandleSubmit(data);
    }

    return (
        <form className="form" onSubmit={handleSubmit(onSubmit)}>
            {isSubmitting && <Loading/>}
            <Controller control={control} name="fromDomain" render={({field}) => (
                <InputField label="Tên miền hiện tại" errors={errors} {...field}/>
            )}/>
            <Controller control={control} name="toDomain" render={({field}) => (
                <InputField label="Tên miền mới" errors={errors} {...field}/>
            )}/>
            <hr />
            <div className="form-group d-flex justify-content-end modal-bottom">
                <Button primary type="submit">Tạo yêu cầu</Button>
            </div>
        </form>
    )
}

export default ToDoFormRedirectDomain;